import roleRoutes from './modules/role';
import configRoutes from './modules/config';
import modelRoutes from './modules/model';
import logsRoutes from './modules/logs';
import siteRouters from './modules/site';
import deviceRouters from './modules/device';
import customerRouters from './modules/customer';
import userRouters from './modules/user';
import docsRouters from './modules/docs';
import messageRouters from './modules/message';
import applicationRouters from './modules/application';
import attachRouters from './modules/attach';

/**
 * authKey：设置为[]表示不需要权限，不设置或设置为值都是需要对应权限的（没有则不显示）
 */

const manageRoutes = [
  // 欢迎页面
  {
    path: 'noauth',
    name: 'NoAuth',
    component: () => import(/* webpackChunkName: "Welcome" */ '@/components/NoAuth'),
    meta: {
      authKey: [],
      sidebar: false,
      title: 'com_sider_menu_no_auth',
      disabled: false,
      pageloading: false,
      autoCollect: false,
    },
  },

  // 欢迎页面
  {
    path: 'welcome',
    name: 'Welcome',
    component: () => import(/* webpackChunkName: "Welcome" */ '@/views/welcome'),
    meta: {
      authKey: [],
      sidebar: false,
      title: 'com_sider_menu_welcome',
      disabled: false,
      icon: 'welcome',
      pageloading: false,
      autoCollect: false,
    },
  },

  // 用户管理 - 编辑自己
  {
    path: 'my',
    name: 'My',
    component: () => import(/* webpackChunkName: "UserEdit" */ '@/views/my'),
    meta: {
      authKey: ['auth_my'],
      sidebar: false,
      title: 'com_sider_menu_my',
      disabled: false,
      icon: null,
    },
  },

  // 首页
  {
    path: 'home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '@/views/home'),
    meta: {
      sidebar: 1,
      // 可查看桩的状态
      authKey: ['auth_home'],
      title: 'com_sider_menu_home',
      disabled: false,
      icon: 'menu_home',
    },
  },

  // docs
  ...docsRouters,

  // site
  ...siteRouters,

  // device
  ...deviceRouters,

  // 消息
  ...messageRouters,

  // 附件
  ...attachRouters,

  // 系统管理
  // 系统管理的path为system，不可轻易修改，因为src/components/Layout/index.vue有判断
  {
    path: 'system',
    name: 'System',
    component: () => import(/* webpackChunkName: "SystemMain" */ '@/views/content'),
    meta: {
      sidebar: 2,
      authKey: ['auth_system'],
      title: 'com_sider_menu_system',
      disabled: false,
      icon: 'menu_setting',
      hasChildrenMenu: true,
      hide: true,
      breadcrumb: false,
    },
    children: [
      // welcome
      {
        path: 'welcome',
        name: 'SystemWelcome',
        component: () => import(/* webpackChunkName: "SystemDashboard" */ '@/views/system/welcome'),
        meta: {
          sidebar: false,
          authKey: ['auth_system'],
          title: 'com_sider_menu_system_welcome',
          disabled: false,
          icon: 'menu_system',
        },
      },

      // 系统总览
      {
        path: 'dashboard',
        name: 'SystemDashboard',
        component: () =>
          import(/* webpackChunkName: "SystemDashboard" */ '@/views/system/dashboard'),
        meta: {
          sidebar: 2,
          authKey: ['auth_system', 'auth_system_dashboard'],
          title: 'com_sider_menu_system_dashboard',
          disabled: false,
          icon: 'menu_system',
        },
      },

      // 客户
      ...customerRouters,

      // 用户
      ...userRouters,

      // 菜单管理
      {
        path: 'menu',
        name: 'Menu',
        component: () => import(/* webpackChunkName: "Menu" */ '@/views/system/menuInterface'),
        meta: {
          sidebar: 2,
          authKey: ['auth_system', 'auth_menu'],
          title: 'com_sider_menu_and_interface',
          disabled: false,
          icon: 'menu_manage',
        },
      },

      // 角色
      ...roleRoutes,

      // 配置
      ...configRoutes,

      // 模型
      ...modelRoutes,

      // 日志
      ...logsRoutes,

      // 应用接入
      ...applicationRouters,

      // 黑名单管理
      {
        path: 'list',
        name: 'BlackList',
        component: () => import(/* webpackChunkName: "BlackList" */ '@/views/system/blacklist'),
        meta: {
          sidebar: 2,
          authKey: ['auth_black_device'],
          breadcrumb: true,
          title: 'com_sider_menu_black',
          disabled: false,
          icon: 'menu_black_list',
        },
      },
    ],
  },
];

export default manageRoutes;
